import { Component } from '@angular/core';
import { LocaleService } from './_utility';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { SpinnerService } from './_components/spinner/spinner.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'my-italian';

  constructor(
    private route: Router,
    private locale: LocaleService,
    private spinner: SpinnerService,
  ) {
    this.locale.init();
  }
}
